import { render, staticRenderFns } from "./CheckCardPromoEligibility.vue?vue&type=template&id=1d5f3d4a&scoped=true&"
import script from "./CheckCardPromoEligibility.vue?vue&type=script&lang=js&"
export * from "./CheckCardPromoEligibility.vue?vue&type=script&lang=js&"
import style0 from "./CheckCardPromoEligibility.vue?vue&type=style&index=0&id=1d5f3d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5f3d4a",
  null
  
)

export default component.exports